// Mock data para consultoria de montagem de computadores

export const consultingPlans = [
  {
    id: 1,
    title: "Básico",
    description: "Para computadores até R$ 4.000",
    price: 450,
    installmentPrice: 45,
    installments: "10x de R$ 45,00",
    cashDiscount: "5% à vista",
    features: [
      "Consultoria na escolha das peças",
      "Até 6 opções diferentes de setup",
      "Compatibilidade garantida",
      "Testes de estabilidade",
      "Montagem profissional",
      "Instalação do sistema operacional",
      "Configuração inicial",
      "Auxílio durante 3 meses em defeitos",
      "Serviço de diagnóstico disponível",
      "Busca por cupons de desconto"
    ]
  },
  {
    id: 2,
    title: "Intermediário",
    description: "Para computadores de R$ 4.500 a R$ 6.500",
    price: 550,
    installmentPrice: 55,
    installments: "10x de R$ 55,00",
    cashDiscount: "5% à vista",
    features: [
      "Consultoria especializada",
      "Até 8 opções diferentes de setup",
      "Análise de custo-benefício",
      "Testes avançados de performance",
      "Otimização de sistema",
      "Benchmarks completos",
      "Configuração para games/trabalho",
      "Auxílio durante 6 meses em defeitos",
      "Serviço de diagnóstico prioritário",
      "Busca intensiva por cupons de desconto"
    ]
  },
  {
    id: 3,
    title: "Premium",
    description: "Para computadores acima de R$ 7.000",
    price: 650,
    installmentPrice: 65,
    installments: "10x de R$ 65,00",
    cashDiscount: "5% à vista",
    priceNote: "Valor varia conforme complexidade",
    features: [
      "Consultoria premium personalizada",
      "Até 10 opções diferentes de setup",
      "Projetos de alta performance",
      "Overclock profissional",
      "Sistema de refrigeração customizado",
      "RGB e estética personalizada",
      "Testes de stress completos",
      "Auxílio durante 12 meses em defeitos",
      "Serviço de diagnóstico vitalício",
      "Garantia estendida",
      "Busca exclusiva por cupons e promoções"
    ]
  }
];

export const instagramPosts = [
  {
    id: 1,
    title: "Remontagem PC Gamer",
    description: "Setup completo para jogos em 1440p com RGB customizado",
    image: "https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=400&h=400&fit=crop",
    likes: 1247,
    comments: 89,
    type: "reel",
    url: "https://www.instagram.com/reel/C2ulS0QLzX3/?igsh=MW1rbXRnbGw3bTAycg=="
  },
  {
    id: 2,
    title: "3 erros montagem do PC",
    description: "Dicas importantes para evitar erros comuns",
    image: "https://images.unsplash.com/photo-1587831990711-23ca6441447b?w=400&h=400&fit=crop",
    likes: 892,
    comments: 56,
    type: "reel",
    url: "https://www.instagram.com/reel/C4tjneSvDnS/?igsh=MXZqZHF6MnkxNWgybA=="
  },
  {
    id: 3,
    title: "Instagram vs realidade",
    description: "Bastidores da montagem profissional",
    image: "https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=400&h=400&fit=crop",
    likes: 743,
    comments: 34,
    type: "reel",
    url: "https://www.instagram.com/reel/C4q-nspPZZ7/?igsh=cG42NDJhNnc2Mmcx"
  },
  {
    id: 4,
    title: "Restauração Acer Nitro",
    description: "Processo completo de restauração",
    image: "https://images.unsplash.com/photo-1593640408182-31c70c8268f5?w=400&h=400&fit=crop",
    likes: 1156,
    comments: 67,
    type: "reel",
    url: "https://www.instagram.com/reel/C5npQDELz-v/?igsh=bHNmM2lyMThpZjJu"
  },
  {
    id: 5,
    title: "Gargalo no Processador",
    description: "Como identificar e resolver gargalos",
    image: "https://images.unsplash.com/photo-1551033406-611cf9a28f67?w=400&h=400&fit=crop",
    likes: 2034,
    comments: 123,
    type: "reel",
    url: "https://www.instagram.com/reel/C6HwwuMP_A0/?igsh=ZHB5anEyMW5leHVi"
  },
  {
    id: 6,
    title: "Consultoria PC White",
    description: "Setup minimalista com performance excepcional",
    image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop",
    likes: 1687,
    comments: 98,
    type: "reel",
    url: "https://www.instagram.com/reel/C6Zkp9hPdnG/?igsh=MXJ0aGhyZzR4c2NpZg=="
  },
  {
    id: 7,
    title: "Revisão Alienware",
    description: "Análise completa do setup gamer",
    image: "https://tecnotesjc.com.br/wp-content/uploads/2024/05/Revisao-Alienware.jpg",
    likes: 1532,
    comments: 78,
    type: "post",
    url: "https://www.instagram.com/reel/C6FCP5Ovo-P/?igsh=OXFmYTJxdXU3a2Fq"
  },
  {
    id: 8,
    title: "Foto PC RTX 4060",
    description: "Build completo para games modernos",
    image: "https://tecnotesjc.com.br/wp-content/uploads/2024/05/Foto-PC-RTX-4060-scaled.jpg",
    likes: 1245,
    comments: 65,
    type: "post",
    url: "https://www.instagram.com/p/C3s9K0iPBPf/?igsh=MTl2aGtlbHIwZ2I5bg=="
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    rating: 5,
    comment: "Excelente consultoria! Me ajudaram a escolher as peças certas e economizei mais de R$ 800 comparado a outras opções. O PC ficou perfeito!",
    project: "PC Gamer RTX 4060"
  },
  {
    id: 2,
    name: "Marina Santos",
    rating: 5,
    comment: "Profissionais incríveis! Montaram meu setup para trabalho e ficou sensacional. Suporte pós-montagem foi excepcional.",
    project: "Workstation para Design"
  },
  {
    id: 3,
    name: "João Pedro",
    rating: 5,
    comment: "Melhor investimento que fiz! A consultoria me mostrou opções que eu nem sabia que existiam. Recomendo 100%!",
    project: "PC Premium Ryzen 9"
  },
  {
    id: 4,
    name: "Ana Rodrigues",
    rating: 5,
    comment: "Atendimento personalizado e resultado impecável. Meu PC roda todos os jogos no ultra sem problemas!",
    project: "Setup Gaming 4K"
  }
];

export const advantages = [
  {
    icon: "TrendingDown",
    title: "Economia Garantida",
    description: "Conhecimento do mercado para encontrar as melhores ofertas e evitar gastos desnecessários"
  },
  {
    icon: "Shield",
    title: "Compatibilidade Assegurada",
    description: "Evite dores de cabeça com peças incompatíveis. Garantimos que tudo funcione perfeitamente"
  },
  {
    icon: "Zap",
    title: "Performance Otimizada",
    description: "Configurações precisas para extrair o máximo desempenho do seu investimento"
  },
  {
    icon: "Clock",
    title: "Múltiplas Opções de Setup",
    description: "Com o orçamento do projeto, criamos diversas opções de setup e configurações de acordo com suas vontades"
  },
  {
    icon: "Users",
    title: "Cupons de Desconto",
    description: "Encontramos cupons de desconto no dia da consultoria para maximizar sua economia"
  },
  {
    icon: "Cable",
    title: "Organização de Cabos Profissional",
    description: "Organização impecável de cabos por profissionais da área, deixando seu setup perfeito"
  },
  {
    icon: "Award",
    title: "8+ Anos de Experiência",
    description: "Mais de 500 PCs montados com sucesso e clientes satisfeitos"
  }
];

export const faqData = [
  {
    question: "Quanto tempo demora para montar meu computador?",
    answer: "O prazo é de 2 a 3 dias úteis, dependendo da complexidade do projeto e disponibilidade das peças no mercado."
  },
  {
    question: "Posso ter até quantas opções de setup com esse orçamento?",
    answer: "O cliente pode ter 6, 8 ou 10 diferentes orçamentos dependendo do plano escolhido. O prazo para compra é de 24h porque podem expirar os cupons e os valores alterarem."
  },
  {
    question: "Vocês vão informando o desenvolvimento do processo?",
    answer: "Sim! Enviamos fotos de todo o processo para você ficar antenado via WhatsApp durante toda a montagem."
  },
  {
    question: "Qual meio de contato da consultoria?",
    answer: "Agendamos a consultoria na loja ou online, de acordo com a necessidade do cliente, mas sempre damos prioridade para a consultoria local, para conhecer nossa equipe que vai te atender."
  },
  {
    question: "Vocês oferecem garantia?",
    answer: "Sim! Oferecemos auxílio durante 3, 6 ou 12 meses conforme o plano escolhido, além de serviço de diagnóstico especializado."
  },
  {
    question: "Posso escolher as peças que quero?",
    answer: "Claro! Nossa consultoria respeitará suas preferências e orçamento, sugerindo as melhores opções dentro do seu perfil de uso."
  },
  {
    question: "E se eu quiser fazer upgrade depois?",
    answer: "Planejamos seu PC pensando em upgrades futuros. Oferecemos consultoria para melhorias e expansões quando necessário."
  },
  {
    question: "Vocês instalam programas e jogos?",
    answer: "Sim! Fazemos a instalação completa do sistema operacional, drivers, programas essenciais e podemos instalar seus jogos favoritos."
  }
];

export const contactInfo = {
  phone: "(12) 99717-6654",
  whatsapp: "5512997176654",
  email: "contato@tecnotesjc.com.br",
  address: {
    street: "Rua Targino Cardoso de Araujo, nº 23",
    district: "Vila Cristina",
    city: "São José dos Campos",
    state: "SP",
    cep: "12211-137"
  },
  social: {
    instagram: "@tecnote_store",
    facebook: "@tecnoteassistencia"
  }
};